import {GetReverseGeocodeParams} from 'domain/usecases/private/profile/get-reverse-geocode';
import {makeGetReverseGeocode} from 'main/factories/usecases/private/profile/get-reverse-geocode';

export async function getReverseGeocode(params: GetReverseGeocodeParams) {
	const response = await makeGetReverseGeocode().get(params);

	return response;
}
